/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_box_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`With linear interpolation (the common type-7 method), so the quartiles match those reported by most spreadsheet and statistics tools.`)
};

const es_box_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Con interpolación lineal (el método común tipo 7), así que los cuartiles coinciden con los reportados por la mayoría de las herramientas de hojas de cálculo y estadística.`)
};

const de_box_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit linearer Interpolation (der gängigen Typ-7-Methode), sodass die Quartile mit denen der meisten Tabellenkalkulations- und Statistik-Tools übereinstimmen.`)
};

const nl_box_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Met lineaire interpolatie (de gangbare type-7-methode), zodat de kwartielen overeenkomen met die van de meeste spreadsheet- en statistiektools.`)
};

const fr_box_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Par interpolation linéaire (la méthode courante de type 7), afin que les quartiles correspondent à ceux rapportés par la plupart des tableurs et outils statistiques.`)
};

const it_box_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Con interpolazione lineare (il comune metodo tipo 7), così i quartili corrispondono a quelli riportati dalla maggior parte dei fogli di calcolo e degli strumenti statistici.`)
};

const pt_br2_box_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Com interpolação linear (o método comum tipo 7), para que os quartis correspondam aos relatados pela maioria das planilhas e ferramentas estatísticas.`)
};

const pt_box_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por interpolação linear (o método comum de tipo 7), pelo que os quartis correspondem aos indicados pela maioria das folhas de cálculo e ferramentas estatísticas.`)
};

const ja_box_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`線形補間（一般的なタイプ7法）で計算されるため、ほとんどのスプレッドシートや統計ツールが報告する四分位数と一致します。`)
};

const zh_box_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用线性插值（常见的第 7 类方法），因此计算出的四分位数与大多数电子表格和统计工具报告的结果一致。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const box_faq_a3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.box_faq_a3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("box_faq_a3", locale)
	if (locale === "en") return en_box_faq_a3(inputs)
	if (locale === "es") return es_box_faq_a3(inputs)
	if (locale === "de") return de_box_faq_a3(inputs)
	if (locale === "nl") return nl_box_faq_a3(inputs)
	if (locale === "fr") return fr_box_faq_a3(inputs)
	if (locale === "it") return it_box_faq_a3(inputs)
	if (locale === "pt-BR") return pt_br2_box_faq_a3(inputs)
	if (locale === "pt") return pt_box_faq_a3(inputs)
	if (locale === "ja") return ja_box_faq_a3(inputs)
	return zh_box_faq_a3(inputs)
};